export default function Banner() {
    return (
        <div className="announcement-banner" role="status">
            <div className="announcement-banner__content">
                UNCLASSIFIED//CONTROLLED UNCLASSIFIED INFORMATION (CUI)//NATIONAL SECURITY SYSTEMS (NSS)
            </div>
        </div>
    );
}
